import { render, staticRenderFns } from "./Liquitech.vue?vue&type=template&id=59e60a05&class=true&"
import script from "./Liquitech.vue?vue&type=script&lang=ts&"
export * from "./Liquitech.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports